import script from "./FileInput.vue?vue&type=script&setup=true&lang=js"
export * from "./FileInput.vue?vue&type=script&setup=true&lang=js"

import "./FileInput.vue?vue&type=style&index=0&id=a4b793c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4b793c2"]])

export default __exports__